import * as React from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap'

export default function CustomerView({
    customer
}) {
    if (!customer) return null;
    return (
        <Card className="card-box">
            <CardHeader>
                <h4 className="font-size-lg mb-0 py-0 font-weight-bold">
                    Dati Cliente
                </h4>
            </CardHeader>
            <CardBody className="px-4 pt-3">

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b className="text-dark">Nominativo</b>
                    </div>
                    <div className="font-weight-bold text-first font-size-lg">
                        {customer.name}
                    </div>
                </div>

                <div className="divider my-3" />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b className="text-dark">Codice Centrale Operativa</b>
                    </div>
                    <div className="font-weight-bold text-danger font-size-lg">
                        {customer.attributes.ticket ? customer.attributes.ticket : "N.D."}
                    </div>
                </div>

                <div className="divider my-3" />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b className="text-dark">Tipo di Cliente</b>
                    </div>
                    <div className="font-weight-bold text-first font-size-lg">
                        {customer.category}
                    </div>
                </div>

                <div className="divider my-3" />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b className="text-dark">Indirizzo</b>
                    </div>
                    <div className="font-weight-bold text-first font-size-lg">
                        {customer.address.street + " - " + customer.address.cap + " " + customer.address.city + " (" + customer.address.province + ")"}
                    </div>
                </div>

                <div className="divider my-3" />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b className="text-dark">Telefono</b>
                    </div>
                    <div className="font-weight-bold text-first font-size-lg">
                        {customer.attributes.phone}
                    </div>
                </div>

                <div className="divider my-3" />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <b className="text-dark">Email</b>
                    </div>
                    <div className="font-weight-bold text-first font-size-lg">
                        {customer.email}
                    </div>
                </div>

            </CardBody>
        </Card>
    );
}
